<template >
<div class="report-container page-container">
  <div class="cover">
    <div v-if="islogoLenovo" style="height:64px"></div>
    <img v-else class="logo" src="@/assets/img/report_logo.png"/>
    <div class="report-info">
      <h1>
        <p>知识漏洞大体检报告</p>
        <p><span>Knowledge</span><span>Diagnosis</span><span>Report</span></p>
      </h1>
      <h2><span>{{subjectName}}</span>&nbsp;|&nbsp;
        <span>{{grade}}</span>&nbsp;|&nbsp;<span>{{version}}</span>
      </h2>
      <h2 v-html="reportName">报告名称</h2>
      <!-- <h3>【 专题名称一二三四五六 】</h3> -->
      <div class="user-info">
        <p>学生姓名：{{stuName}}</p>
        <p>完成时间：{{finishTime}}</p>
      </div>
    </div>
  </div>
  <section class="area-section" :class="[{'area-section-lenovo':islogoLenovo}]">

    <div class="report-title">
      <h1>测评概览</h1>
      <p>Assessment Overview</p>
    </div>

    <module-knowlege-detail
      moduleTitle="知识点掌握详情"
      :knowlegeDetailData="knowlegeMasterDetail"/>

    <module-all-time
      moduleTitle="测评用时"
      :allTimeData="allTimeCompare"
      ref="allTimeResult"
    />

    <module-right-rate
      moduleTitle="题目正答率"
      :rightData="allRight"
      ref="rightRateResult"
    />

    <ModuleKDATarget
      moduleTitle="KDA指标"
      :kdaData="kdaData"/>

  </section>
  <section class="area-section" :class="[{'area-section-lenovo':islogoLenovo}]">
    <div class="report-title">
      <h1>测评详情</h1>
      <p>Assessment  Details</p>
    </div>

    <!--<module-knowlege-atlas-->
      <!--moduleTitle="知识图谱"-->
      <!--:mapData="kmap"/>-->

    <module-knowlege-analyze
      moduleTitle="知识点分析"
      :analyzeData="knowlegeAnalyze"
      ref="knowlegeAnalyzeResult"
    />

    <module-exam
      v-if="examAnalyzeData.type"
      moduleTitle="中考分析"
      :examData="examAnalyzeData"
      ref="examAnalyze"
    />
  </section>
  <section class="area-section" v-if="missData.length"
   :class="[{'area-section-lenovo':islogoLenovo}]">
    <div class="report-title">
      <h1>课时规划</h1>
      <p>Learning Plan</p>
    </div>
    <module-knowlege-miss
      v-if="missData.length"
      moduleTitle="知识漏洞分析"
      chartId="knowlegeMiss"
      :miss-data="missData"
      :is-mobile="false"
      ref="knowlegeMiss"
    />

    <module-knowlege-miss-pie
      v-if="missData.length"
      moduleTitle=""
      chartId="knowlegeMiss"
      :miss-pie-data="missPieData"
      :is-mobile="false"
      ref="knowlegeMiss"
    />

    <div class="miss-point-text" v-if="missPieData.length">
      AI系统根据测试结果预估，你在{{missPieData[0].name}}的同步课共有{{ missPoint }}个知识漏洞，
        <template v-if="nowMasterRate <= 0.2">同步课的学习效率较低。</template>
      这是因为，在过去的低年级的学习中，遗留了一些的知识漏洞。如果不去及时填补这些知识漏洞，一个学期后，同步课的学习效率将进一步降低20%。
    </div>

    <module-map-dadiji
      v-if="examAnalyzeData.type"
      moduleTitle=""
      :type="examAnalyzeData.type"
      :is-mobile="false"
      ref="mapDadiji"
    />

    <module-learn-plan
      v-if="foundation.foundationLoNum"
      :is-mobile="false"
      :plan-data="foundation"
      moduleTitle="学习规划"
      ref="leranPlan"
    />
  </section>
  <button class="detail-btn"
  @click="onDetailClick">
    查看答题详情
  </button>

  <el-dialog
    title=""
    :visible.sync="dialog.is_show"
    width="800">
    <div style="display: flex;width:100%">
      <span class="dialog-img01">
        <img src="@/assets/img/illustration01.png" width="176" /></span>
      <span class="dialog-text">
        <h1>测评完成!</h1>
        <p v-for="(item, index) in dialog.bodyText" :key="index">{{item}}</p>
      </span>
      <span slot="footer" class="dialog-footer">
    </span>
    </div>
  </el-dialog>
  <div
   id="print"
   @click="print"
   v-if="!isPad"><img src="~@/assets/img/ic_local@2x.png" alt="">打印报告</div>
</div>
</template>

<script>
/* eslint-disable */
import ModuleKnowlegeDetail from './components/ModuleKnowlegeDetail';
import ModuleAllTime from './components/ModuleAllTime';
import ModuleRightRate from './components/ModuleRightRate';
import ModuleKDATarget from './components/ModuleKDATarget';
import ModuleKnowlegeAtlas from './components/ModuleKnowlegeAtlas';
import ModuleKnowlegeAnalyze from './components/ModuleKnowlegeAnalyze';
import ModuleExam from './components/ModuleExam';
import ModuleKnowlegeMiss from './components/ModuleKnowlegeMiss';
import ModuleKnowlegeMissPie from './components/ModuleKnowlegeMissPie';
import ModuleMapDadiji from './components/ModuleMapDadiji';
import ModuleLearnPlan from './components/ModuleLearnPlan';
import { getSign } from '@/pages/dl-web/utils/verify';
import api from '@/pages/dl-web/api/api';
import { openTab } from '@/utils';

export default {
  name: 'report',
  data() {
    return {
      tsid: this.$route.query.id,
      isPad: /mobile|ipad/i.test(navigator.userAgent),
      action: this.$route.query.action || 0, // 1入学测
      reportName: '',
      subjectName: '',
      grade: '',
      version: '',
      stuName: '',
      finishTime: '',
      foundation: {}, // 打地基
      knowlegeMasterDetail: {}, // 知识点掌握情况数据
      allTimeCompare: {}, // 测评用时数据
      allRight: {}, // 正确率数据
      kdaData: {}, // KDA指标
      kmap: [], // 知识图谱数据
      knowlegeAnalyze: [], // 知识点分析数据
      examAnalyzeData: {}, // 中考分析
      missPoint: 0, // 当前年级漏洞知识点
      missData: [], // 漏洞对比
      missPieData: [], // 漏洞占比
      nowMasterRate: '', // 当前年级 掌握程度
      dialog: {
        is_show: false,
        dialogVisible: false,
        bodyText: ['为更好地提高测评后的学习能力，稍后48小时内乂学教育松鼠AI老师致电给您提供一节免费在线人工智能测评课，自愿选择，一起为智能学习增砖加瓦！'],
      },
    };
  },
  components: {
    ModuleKnowlegeDetail, // 知识点掌握情况
    ModuleAllTime, // 测评用时
    ModuleRightRate, // 正确率
    ModuleKDATarget, // KDA指标
    ModuleKnowlegeAtlas, // 知识图谱
    ModuleKnowlegeAnalyze, // 知识点分析
    ModuleExam, // 中考分析
    ModuleKnowlegeMiss, // 知识漏洞分析
    ModuleKnowlegeMissPie, // 知识漏洞占比
    ModuleMapDadiji, // 打地基图谱
    ModuleLearnPlan, // 学习规划
  },
  mounted() {
    console.log(123123123);
    this.initData();
  },
  computed:{
    //判断是否是特殊校区
    islogoLenovo(){
      let id = this.$route.query.schoolId || localStorage.getItem('school_id') 
      || '';
      return id ==='20023' || id === '20022' || id === '20043' || id === '2217';
    }
  },
  methods: {
    onDetailClick() {
      this.$router.push({
        path: '/dl-web/question/questionDetail',
        query:{tsid:this.$route.query.id,schoolId:this.$route.query.schoolId}
      });
    },
    async initData() {
      const params = {
        tsid: this.tsid,
        action: this.action,
        time_stamp: (new Date()).getTime(),
      };
      params.sign = getSign(params);
      const resOne = await api.getReportpart1(params); // 获取报告页第一部分
      if (resOne) {
        if (resOne.code === 0) {
          const { data } = resOne;
          this.reportName = data.report_info.unit || '';
          this.subjectName = data.report_info.subject || '';
          this.grade = data.report_info.grade || '';
          this.version = data.report_info.version || '';
          this.stuName = data.report_info.user_name || '';
          this.finishTime = data.report_info.date || '';
          this.knowlegeMasterDetail = data.knowledge_info || {}; // 知识点掌握详情
          this.allTimeCompare = data.time_info || ''; // 我的用时
          this.allRight = data.question_info || ''; // 题目正答率
          this.examAnalyzeData = data.percent || {};
          this.dialog.is_show = data.is_show == 0; // 弹框是否显示
          // ==构造打地基漏洞数据
          if (data.foundation && Object.keys(data.foundation).length) {
            this.missData = data.foundation.gradeInfoList || [];
            const { foundation = {} } = data; // 漏洞
            const { gradeId = '' } = (foundation && foundation.nowGradeInfoList) || '';
            let dadijiData = [];
            this.nowMasterRate = foundation.nowGradeInfoList.nowMasterRate || '';
            this.missPoint = foundation.nowGradeInfoList.loopholeLoNum || 0;
            dadijiData = foundation.gradeInfoList && foundation.gradeInfoList.filter((item) => item.gradeId !== gradeId);
            const dadjText = dadijiData.length > 1
              ? `${dadijiData[0].gradeId}~${dadijiData[dadijiData.length - 1].gradeId}年级` : `${dadijiData[0].gradeId}年级`;
            this.missPieData.push({
              name: `${gradeId}年级`,
              value: foundation.nowGradeInfoList.loopholeLoNum,
              selected: true,
            });
            this.missPieData.push({
              name: dadjText,
              value: foundation.foundationLoNum,
            });
            this.foundation = foundation;
          }
          // ===构造打地基漏洞数据
          this.$nextTick(() => {
            this.$refs.allTimeResult.renderResult();
            this.$refs.rightRateResult.renderRateResult();
            this.$refs.examAnalyze.renderData();
          });
        } else {
          this.$toast(resOne.msg);
        }
      }
      const resTwo = await api.getReportpart2(params); // 报告页第二部分
      if (resTwo) {
        if (resTwo.code === 0) {
          this.kdaData = resTwo.data;
        }
      }
      const resThree = await api.getReportpart3(params); // 报告页第三部分
      if (resThree) {
        if (resThree.code === 0) {
          this.knowlegeAnalyze = resThree.data;
          this.$nextTick(() => {
            this.$refs.knowlegeAnalyzeResult.renderAnalyzeResult();
          });
        }
      }
    },
    print() {
      this.$refs.mapDadiji && this.$refs.mapDadiji.showImg();
      this.$nextTick(() => {
        window.print();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  // @m: 1/16rem;
.report-container {
    position: relative;
    width: 794px;
    margin: 0 auto;
    background: #0D30BD;
    min-height: 100%;
    padding-bottom: 72px;
    .cover {
      height: 640px;
      background: url("~@/assets/img/report_bg.jpg") no-repeat;
      background-size: cover;
      padding-top: 20px;
      .logo {
        display: block;
        width: 250px;
        margin: 0 auto 32px auto;
      }
      .report-info {
        padding: 52px 0 20px 0;
        text-align: center;
        color: #fff;
        h2 {
          font-size: 20px;
          text-align: center;
          line-height: 20px;
          margin-bottom: 14px;
          font-weight: 500;
        }
        h1 {
          text-align: center;
          line-height: 32px;
          margin-bottom: 10px;
          font-weight: bold;
          > p {
            &:first-child{
              font-size: 34px;
            }
            &:last-child{
              font-size: 16px;
              font-weight: 400;
              >span{
                padding: 0 15px;
              }
            }
          }
        }
        .user-info {
          display: flex;
          justify-content: center;
          font-size: 14px;
          color: #B9E4FF;
          letter-spacing: 0;
          p {
            margin: 0 15px 15px 15px;
            text-align: left;
          }
        }
      }
    }
    .section-wrap {
      padding: 0 27px 80px 27px;
      background-image: linear-gradient(-90deg, #3D00D9 0%, #4000E2 15%, #1870FF 100%);
    }
    .next-btn{
      width: 320px;
      height: 48px;
      display: block;
      background: #FFFFFF;
      border-radius: 24px;
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #333333;
      line-height: 48px;
      margin:64px auto 0;
    }
    .area-section-lenovo{
      background: #FFF !important;
    }
    .area-section{
      margin: 0 3.4%;
      background: #FFF url("~@/assets/img/report_sy_bg.png") repeat;
      border-radius: 10px;
      margin-bottom: 64px;
      padding-bottom: 24px;
      .report-title{
        text-align: center;
        h1{
          width: 376px;
          height: 160px;
          line-height: 160px;
          margin: 0 auto;
          background: url("~@/assets/img/title_report_bg.png") no-repeat;
          background-size: cover;
          font-size: 28px;
          color: #FFF;
          letter-spacing: 0;
        }
        p{
          font-size: 14px;
          color: #999;
          letter-spacing: 0;
          margin-top: -40px;
        }
      }
      .module-wrap{
        h2{
          width: 358px;
          height: 40px;
          margin: 58px auto 32px auto;
          font-size: 20px;
          line-height: 40px;
          text-align: center;
          background: url("~@/assets/img/sub_headbg.png") no-repeat;
          background-size: cover;
        }
      }
    }
    .miss-point-text{
      margin: 32px;
      padding: 12px;
      background: linear-gradient(90deg, #E4EAFF 0%, #E1F5FF 100%);
      border-radius: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
    .detail-btn{
      width:280px;
      height:48px;
      background:rgba(255,255,255,1);
      border-radius:24px;
      font-size:20px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(0,177,255,1);
      line-height:48px;
      display: block;
      text-align: center;
      margin: 0 auto;
      text-decoration: none;
    }
  }
.el-dialog{
  border-radius: 10px;
  width: 800px;
  .el-dialog__body{
    padding: 6px 20px 36px 20px;
  }
  .dialog-img01{
    margin-left: 98px;
    margin-right: 76px;
  }
  .dialog-text{
    display: inline-block;
    width: 342px;
    vertical-align: top;
    padding-top: 80px;
    h1{
      margin-bottom: 28px;
      font-family: PingFangSC-Semibold;
      font-size: 44px;
      color: #4A4A4A;
      text-align: center;
    }
    p{
      font-family: PingFangSC-Light;
      font-size: 18px;
      color: #4A4A4A;
      letter-spacing: 0;
      text-align: left;
      line-height: 28px;
    }
  }
}
#print{
  position: fixed;
  top: 46px;
  right: 40px;
  font-size: 18px;
  color: rgba(51,51,51,.8);
  z-index: 10001;
  cursor: pointer;
}
#print img {
  width: 20px;
  height: 18px;
  margin-right: 6px;
}
@media screen  and(min-width:1366px) and (max-width: 1440px) {
  .el-dialog{
    width: 55%;
  }
}
@media screen and (min-width: 1500px) {
  .el-dialog{
    width: 50%;
  }
}
@media print {
  .report-container,
  .report-container .area-section{
    padding-bottom: 0;
    margin-bottom: 0;
  }
  .report-container .cover{
    height: 340px!important;
  }
  #print, .el-progress-circle, .detail-btn{
    display: none!important;
  }
  /*.el-progress--circle .el-progress__text{*/
    /*width: 126px!important;*/
    /*text-align: left;*/
    /*margin-left: -30px;*/
  /*}*/
  .report-container .area-section .module-wrap h2{
    margin-top: 20px;
  }
}
</style>
